// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"total-tickets-counts__wrapper__2KesG","icon-wrapper":"total-tickets-counts__icon-wrapper__3RnhL","total-guest-icon":"total-tickets-counts__total-guest-icon__2VEAW","total-tickets-icon":"total-tickets-counts__total-tickets-icon__1Vb3x","tickets-counts-wrapper":"total-tickets-counts__tickets-counts-wrapper__1U6Va","title":"total-tickets-counts__title__1J48y","sub-label":"total-tickets-counts__sub-label__1Tp3M","order-status":"total-tickets-counts__order-status__33RQg","ticket-label":"total-tickets-counts__ticket-label__2ACvg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/rsvp_modal/total-tickets-counts.scss
// module id = 1262
// module chunks = 1